import Chat, { Bubble, useMessages } from '@chatui/core';
import { MessageContainerHandle } from '@chatui/core/lib/components/MessageContainer';
import { trpc } from '@tencent/tpro_rmonitor_ai_server';
import {  Drawer } from 'antd';
import TextArea, { TextAreaRef } from 'antd/lib/input/TextArea';
import { get } from 'lodash-es';
import React, {  Fragment,  useEffect, useRef, useState } from 'react';
import * as uuid from 'uuid';
// 引入样式
import '@chatui/core/dist/index.css';
import BuglyCopilotIcon from '@/assets/images/header/bugly-copilot-icon.svg?react';
import { getUserId } from '@/infrastructure/auth';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { openXmMeter } from '@/infrastructure/reporter/xmMeter';
import { genStandardToken } from '@/proto/token';
import { aiCopilotServer } from '@/service/ai-copilot';
import { WithTypeCast } from '@raft/utils';
import { TopMenuButton } from '../button';
import HistoryModal from './historyModal';
import DrawerClose from './icons/drawer-close.react.svg?react';
import HeaderIcon from './icons/header-icon.react.svg?react';
import SendBtnIcon from './icons/send.react.svg?react';
import style from './index.module.scss';

import { LoadingMessage, RecommandMessage, ResponseTextMessage, TimestampMessage, HistoryRspTextMessage } from './message';

type IMessage = WithTypeCast<trpc.rmonitor.ai_server.IMessage[]>;
type HunyuanMessage = {
  role: 'user' | 'assistant',
  content: string;
};

export const BuglyCopilot = () => {
  const [sessionID, setSessionID] = useState(uuid.v4());
  const [visible, setVisible] = useState(false);
  const [block, setBlock] = useState<boolean>(false);
  const [firstQA, setFirstQA] = useState(false);
  // 某条会话包含的历史记录
  const [historyQA, setHistoryQA] = useState<IMessage>();
  const [initRecId] = useState('initRecId');
  const firstReply = useRef(false);

  // 用来提交给对话模型的对话上下文
  const [gptMessages, setGPTMessages] = useState<HunyuanMessage[]>([]);

  // 当前处理中的消息ID
  const currentMessageRef = useRef<string>('');

  // 控制显示重新生成按钮的状态
  const [enableReGen, setEnableRegen] = useState(true);

  const [composerStyle, setComposerStyle] = useState({
    cursor: '',
    caretColor: '',
    placeholder: '',
    disabled: false,
    overflow: 'hidden',
  });

  const textAreaRef = useRef <TextAreaRef>(null);
  const sendBtnRef = useRef<HTMLDivElement | null>(null);
  const messageListRef = useRef<any>([]);
  const messagesRef = useRef<MessageContainerHandle>(null);

  const { messages, appendMsg, updateMsg, resetList } = useMessages([{
    _id: initRecId,
    type: 'text',
    content: '',
    position: 'left',
  }]);
  const onClick = () => {
    setVisible(true);
  };

  function renderMessageContent(msg: any) {
    const { type, content } = msg;
    switch (type) {
      case 'text':
        return (
          <Bubble >
            {content}
          </Bubble>
        );
      case 'node':
        return (
          content
        );
      case 'icon':
        return (
          <Bubble >
            {content}
          </Bubble>
        );
      default:
        return (
          content
        );
    }
  }

  const getChatMessages = async (gptMsgs: HunyuanMessage[], val: string, messageId?: string) => {
    // 用于组装流式数据
    let textStream = '';
    let queryId = '';
    let docList: any = [];

    // 每一条消息重新生成一个消息ID
    currentMessageRef.current = messageId || uuid.v4();
    const tokenFrom = gptMsgs ? { message: gptMsgs } : {  message: [] };
    const params = await genStandardToken(tokenFrom);
    const source = new EventSource(`/${API_PREFIX}/api/chat/streamCopilot?param=${params}&query=${val}&userId=${getUserId()}&sessionID=${sessionID}`);

    // 插入一条loading消息
    !messageId ? appendMsg({
      _id: currentMessageRef.current,
      type: 'icon',
      content: <LoadingMessage />,
      position: 'left',
    }) : updateMsg(currentMessageRef.current, {
      type: 'icon',
      content: <LoadingMessage />,
      position: 'left',
    });
    updateMsgList();

    source.onmessage = function (event) {
      let sourceData;
      try {
        sourceData = JSON.parse(event.data.replace('data:', '').trim());
      } catch (error) {
        console.log('JSONParse error', error);
      }

      // 取得后台返回的消息queryID
      if (get(sourceData, 'event_type') === 'QUERYID') {
        queryId = get(sourceData, 'event_value');
      }

      // 普通文本消息结构体
      if (get(sourceData, 'event_type') === 'RESULT') {
        const message = get(sourceData, 'event_value', '');
        textStream += message;
        // 更新
        updateMsg(currentMessageRef.current, {
          type: 'responseText',
          content: <ResponseTextMessage
            enableRegen={enableReGen}
            question={val}
            messageId={currentMessageRef.current}
            onReGen={onReGen}
            message={{
              content: textStream,
              queryId,
              docList: [],
            }}
          />,
          position: 'left',
        });
      }

      // 引用资料消息体
      if (get(sourceData, 'event_type') === 'DOCLIST') {
        docList = get(sourceData, 'event_value');
      }

      // 流式数据响应完
      if (get(sourceData, 'event_type') === 'END') {
        updateMsg(currentMessageRef.current, {
          type: 'responseText',
          content: <ResponseTextMessage
            enableRegen={enableReGen}
            finished
            showLike
            question={val}
            onReGen={onReGen}
            messageId={currentMessageRef.current}
            message={{
              content: textStream,
              queryId,
              docList,
            }}
          />,
        });

        source.close();
        setBlock(false);

        setGPTMessages([...gptMsgs as HunyuanMessage[], {
          role: 'assistant',
          content: textStream,
        }]);

        if (!firstReply.current) {
          firstReply.current = true;
          openXmMeter('ip1yry2frrxxxk22pn1l');
        }
      }
    };

    source.onerror = function (error) { // 监听错误
      console.log('sse error', error);
      source.close();
    };
  };

  const onClickPrompt = (text: string) => {
    !block && handleSend('text', text);
  };

  // 初始化推荐问题
  const initRecommendedList = async () => {
    const resp = await aiCopilotServer.getPrompts({ limit: 3 });
    const prompts = resp.querys ?? [];
    updateMsg(initRecId, {
      type: 'text',
      content: <RecommandMessage
        prompts={prompts}
        onClickPrompt={onClickPrompt}
        />,
      position: 'left',
    });
  };

  // 重新发送消息，只需要根据消息ID重新走一遍发送消息流程
  const onReGen = (messageId: string, question: string) => {
    handleSend('text', question, messageId);
  };

  /**
   * 处理发送消息逻辑
   * @param messageType
   * @param value
   * @param messageId 有表示是重新生成的
   */
  const handleSend = (messageType: string, value: string, messageId?: string) => {
    setEnableRegen(true);
    // 如果是第一条提问，插入一条时间消息
    if (firstQA && !messageId) {
      appendMsg({
        type: messageType,
        content: <TimestampMessage />,
        position: 'center',
      });

      setFirstQA(false);
    }

    !messageId && appendMsg({
      type: messageType,
      content: value,
      position: 'right',
    });

    setBlock(true);
    // 开始请求大模型数据
    const contexts = gptMessages.slice(-10);
    getChatMessages(contexts, value, messageId);
  };

  /**
   * 更新消息的【重新发送】展示状态
   */
  const updateMsgList = () => {
    messageListRef.current.forEach((msg: any) => {
      if (visible) {
        if (msg.type === 'responseText' && msg._id !== currentMessageRef.current) {
          updateMsg(msg._id, {
            type: 'responseText',
            content: <ResponseTextMessage
              enableRegen={enableReGen}
              question={msg.content?.props?.question}
              showLike
              onReGen={onReGen}
              messageId={`${msg._id}`}
              message={{
                content: msg.content?.props?.message?.content,
                queryId: msg.content?.props?.message?.queryId,
                docList: msg.content?.props?.message?.docList,
              }}
            />,
          });
        }
      } else {
        if (msg.type === 'responseText') {
          updateMsg(msg._id, {
            type: 'responseText',
            content: <ResponseTextMessage
              enableRegen={enableReGen}
              question={msg.content?.props?.question}
              showLike
              onReGen={onReGen}
              messageId={`${msg._id}`}
              message={{
                content: msg.content?.props?.message?.content,
                queryId: msg.content?.props?.message?.queryId,
                docList: msg.content?.props?.message?.docList,
              }}
            />,
          });
        }
      }
    });
  };


  useEffect(() => {
    if (block) {
      setComposerStyle({
        cursor: 'no-drop',
        caretColor: 'transparent',
        placeholder: '回复中，请稍后输入',
        disabled: true,
        overflow: 'hidden',
      });
    } else {
      setComposerStyle({
        cursor: 'text',
        caretColor: '#ff9000',
        placeholder: '请输入您的问题',
        disabled: false,
        overflow: 'hidden',
      });
    }
  }, [block]);

  useEffect(() => {
    messageListRef.current = messages;
  }, [messages]);

  useEffect(() => {
    if (historyQA) {
      resetList();
      historyQA.forEach((item) => {
        if (item.role === 0) {
          appendMsg({
            type: 'text',
            content: item.content,
            position: 'right',
          });
        } else {
          appendMsg({
            type: 'text',
            content: <HistoryRspTextMessage
              content={item.content}
              docs={item.docs}
            />,
            position: 'left',
          });
        }
      });
    }
  }, [historyQA]);

  useEffect(() => {
    if (visible) {
      setEnableRegen(true);
      setFirstQA(true);
      setSessionID(uuid.v4());
    }
    // 关闭后更新下重新发送状态
    !visible && updateMsgList();
  }, [visible]);

  useEffect(() => {
    if (visible) {
      initRecommendedList();
    }
  }, [firstQA, block]);

  function MyComponent() {
    const [inputValue, setInputvalue] = useState('');
    const sendMsg = (e: any) => {
      if (!(e.key === 'Enter' && e.shiftKey)) {
        e.preventDefault();
        handleSend('text', inputValue);
      }
    };
    const inputChange = (e: any) => {
      setInputvalue(e.target.value);
    };


    return (
      <div className={style.composer}>
        <div className={style.inputWrap}>
          <TextArea
            style={composerStyle}
            className={style.text}
            placeholder={composerStyle.placeholder}
            value={inputValue}
            autoFocus={true}
            onPressEnter={sendMsg}
            onChange={inputChange}
            ref={textAreaRef}
          />
          <div onClick={sendMsg} style={{ cursor: !block ? 'pointer' : 'not-allowed', height: '36px', position: 'relative' }} ref={sendBtnRef}>
            <SendBtnIcon/>
          </div>
        </div>
      </div>
    );
  };


  return (
    <Fragment >
      <Drawer
        className={style.drawer}
        title={<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><BuglyCopilotIcon/>Bugly Copilot</div>}
        visible={visible}
        width={480}
        closeIcon={null}
        extra={<div style={{ display: 'flex' }}>
          <HistoryModal getHistoryDetail={(historyQA: IMessage) => setHistoryQA(historyQA)}/>
          <span onClick={() => {
            setVisible(false);
            setEnableRegen(false);
          }} style={{ marginLeft: '10px', cursor: 'pointer' }}>
            <DrawerClose/>
          </span>
          </div>
        }
        mask={false}
      >
        <Chat
          messages={messages}
          renderMessageContent={renderMessageContent}
          onSend={handleSend}
          Composer={MyComponent}
          messagesRef={messagesRef}
        />
      </Drawer>
      <TopMenuButton  onClick={onClick} >
        <HeaderIcon />
        <span style={{ fontFamily: 'PingFang SC' }}>Bugly Copilot</span>
      </TopMenuButton>
    </Fragment>
  );
};
